export default "__VITE_ASSET__BG40T9l4__"